import * as Yup from 'yup';

import { pharmacyAdminModel } from '../../Admin/PharmacyAdministrators/CreateEditPharmacyAdministrator/validator';

const PharmacistEditProfileValidator = () =>
  Yup.object().shape(pharmacyAdminModel);

export default PharmacistEditProfileValidator;
